/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';

import { Container, Input, Increase, Decrease } from './styles';

const NumberInput = ({ onChange, small, defaultValue, ...props }) => {
  const [value, setValue] = useState(parseInt(defaultValue, 10));
  const step = 1;
  const min = props.min || 0;
  const max = props.max || 100;

  const increase = () => {
    const newValue = value + step;
    setValue(newValue > max ? max : newValue);
  };

  const decrease = () => {
    const newValue = value - step;
    setValue(newValue < min ? min : newValue);
  };

  useEffect(() => {
    setValue(parseInt(defaultValue, 10));
  }, [defaultValue]);

  useEffect(() => {
    onChange(value);
  }, [value]);

  const handleChange = (e) => {
    setValue(Number(e.target.value));
  };

  return (
    <Container className={`number-input ${small ? 'small' : ''}`} {...props}>
      <Decrease onClick={decrease}>-</Decrease>
      <Input
        type="number"
        value={value}
        onChange={handleChange}
        min={min}
        max={max}
        {...props}
      />
      <Increase onClick={increase}>+</Increase>
    </Container>
  );
};

export default NumberInput;
